
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section 
          className="relative h-96 flex items-center justify-center"
          style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20professional%20equipment%2C%20clean%20organized%20environment%2C%20office%20supplies%20and%20technology%2C%20professional%20business%20photography%2C%20bright%20lighting%2C%20minimalist%20style&width=1200&height=400&seq=about-hero&orientation=landscape')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="relative text-center text-white">
            <h1 className="text-4xl font-bold mb-4">关于会找我</h1>
            <p className="text-xl max-w-2xl mx-auto">
              致力于为用户提供优质的办公设备和专业解决方案，打造值得信赖的办公设备电商平台
            </p>
          </div>
        </section>

        {/* Company Introduction */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-6">我们的使命</h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  会找我电商平台成立于2025年，专注于为用户提供优质的办公用品、摄影器材、电子产品和会议设备。我们深知办公效率和产品质量的重要性，
                  因此建立了严格的供应商筛选体系和完善的质量控制流程。
                </p>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  我们的核心理念是"专业、品质、服务"。通过与知名品牌的深度合作，我们确保每一件商品都经过严格的质量检验，
                  为用户提供高效、专业、可靠的办公解决方案。
                </p>
                <div className="grid grid-cols-3 gap-6 mt-8">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-orange-500 mb-2">100万+</div>
                    <div className="text-gray-600">注册用户</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-orange-500 mb-2">5000+</div>
                    <div className="text-gray-600">优质商品</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-orange-500 mb-2">99.5%</div>
                    <div className="text-gray-600">用户满意度</div>
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20office%20equipment%20warehouse%20with%20organized%20shelves%2C%20professional%20storage%20facility%2C%20clean%20environment%2C%20bright%20lighting%2C%20business%20photography&width=600&height=400&seq=about-facility&orientation=landscape"
                  alt="公司设施"
                  className="rounded-lg shadow-lg w-full h-auto object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">核心优势</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-8 text-center shadow-sm">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">品牌正品</h3>
                <p className="text-gray-600 leading-relaxed">
                  直接与知名品牌厂商合作，确保所有商品均为正品行货，让用户享受到最优质的产品。
                  我们建立了完善的供应链管理体系，严格控制每个环节的质量。
                </p>
              </div>
              <div className="bg-white rounded-lg p-8 text-center shadow-sm">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">质量保障</h3>
                <p className="text-gray-600 leading-relaxed">
                  我们对产品质量充满信心，承诺如果收到的商品有质量问题，将提供完善的售后服务。
                  这是我们对用户的郑重承诺，也是我们对产品品质的自信体现。
                </p>
              </div>
              <div className="bg-white rounded-lg p-8 text-center shadow-sm">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">快速配送</h3>
                <p className="text-gray-600 leading-relaxed">
                  与专业物流公司建立战略合作关系，提供快速可靠的配送服务。确保商品在运输过程中保持最佳状态，
                  快速安全地送达用户手中。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 增加一个额外的核心优势部分，使页面更加平衡 */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">我们的服务</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-100">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-headset-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">专业客服</h3>
                    <p className="text-gray-600 leading-relaxed">
                      7x12小时专业客服团队，随时为您解答疑问，提供专业的产品咨询和购买建议，确保您获得满意的购物体验。
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-100">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-refresh-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">无忧退换</h3>
                    <p className="text-gray-600 leading-relaxed">
                      提供7天无理由退换服务，产品质量问题15天包换，让您购物无忧。我们致力于为您提供最优质的售后服务体验。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 bg-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">加入我们的大家庭</h2>
            <p className="text-xl text-orange-100 mb-8">
              体验优质的办公设备，享受专业周到的服务
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/register"
                className="bg-white text-orange-500 px-8 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即注册
              </a>
              <a
                href="/contact"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
